import { useEffect, useRef } from 'react';

export const useEffectOnce = (effect) => {
  const effectFired = useRef(false);
  
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!effectFired.current) {
      effect();
      effectFired.current = true;
    }
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */
};
